import { useTranslation } from 'react-i18next';
import { Text, Link } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const StyledLink = styled(Link)`
  display: inline-block;
  text-decoration: underline;
`;

const surveyLink = 'https://surveys.hotjar.com/898ccca8-3bdc-44b4-8a19-363a8e0c605e';

export const RecordingsOverviewFeedbackLink = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Text as="span" textType="body2" textColor="text_light">
      <StyledLink kind="inline" isExternal href={surveyLink}>
        {`${t('common:recordings.recordings-overview.survey-link')}`}
      </StyledLink>
    </Text>
  );
};
